<template>
  <div class="t-catalog-folders-container">
    <template v-if="isLoading">
      <loading/>
    </template>
    <template v-else>
      <v-layout column fill-height>
        <v-flex>
          <v-layout style="border-bottom: 1px solid #ccc; height: 57px;" align-center justify-center>
            <v-flex xs10>
              <v-text-field
                v-model="search"
                label="Поиск категории"
                prepend-inner-icon="mdi-magnify"
                flat
                solo
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs2 style="border-left: 1px solid #ccc;" fill-height d-flex align-center justify-center>
              <div style="text-align: center;">
                <v-btn
                  color="primary"
                  icon
                  class="toggle-button"
                  @click="toggleExpand"
                >
                  <v-icon>{{treeExpandIcon}}</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="tree-view-container">
          <VuePerfectScrollbar class="scroll-area" :settings="settings">
            <v-treeview
              :items="_foldersTreeContent"
              :search="search"
              :item-key="'nomenklatura_id'"
              :open.sync="open"
              transition
              hoverable
              activatable
            >
              <template slot="label" slot-scope="{ item }">
           <span style="cursor: pointer" @click="loadData(item.nomenklatura_id)">
          <v-icon small style="padding-right: 0;">
            {{item.nomenklatura_id === _currentFolderId && !_getSearchQuery ? 'mdi-folder-outline' : open.indexOf(item.nomenklatura_id)>=0?'mdi-folder-open':'mdi-folder'}}
          </v-icon>
            {{item.name}}
          </span>
              </template>
            </v-treeview>
          </VuePerfectScrollbar>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/helpers/Loading'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: 'CatalogTree',
  components: {
    Loading,
    VuePerfectScrollbar
  },
  data () {
    return {
      open: [],
      search: '',
      isLoading: false,
      currentFolderId: null,
      isTreeExpanded: false,
      settings: {
        // maxScrollbarLength: 60
      }
    }
  },
  computed: {
    ...mapGetters('catalog', {
      _foldersTreeContent: 'foldersTreeContent',
      _currentFolderId: 'currentFolderId',
      _getSearchQuery: 'getSearchQuery'
    }),
    treeExpandIcon () {
      return this.isTreeExpanded ? 'mdi-minus' : 'mdi-plus'
    }
  },
  methods: {
    ...mapActions('catalog', {
      _loadItemsTableContent: 'loadItemsTableContent',
      _loadFoldersTreeContent: 'loadFoldersTreeContent',
      _setCurrentFolderId: 'setCurrentFolderId',
      _toggleTreeSideBar: 'toggleTreeSideBar',
      _setSearchQuery: 'setSearchQuery'
    }),
    openAll (arr) {
      arr.forEach((x) => {
        this.open.push(x.nomenklatura_id)
        if (x.children && x.children.length) {
          this.openAll(x.children)
        }
      })
    },
    toggleExpand () {
      this.isTreeExpanded = !this.isTreeExpanded
      this.open = []
      if (this.isTreeExpanded) {
        this.openAll(this._foldersTreeContent)
      } else {
        this.open = [0]
      }
      // this.$refs.foldersTree.expandAll(this.isTreeExpanded)
    },
    async loadData (folderId) {
      if (folderId) {
        this._setSearchQuery('')
        // this.searchQuery = ''
        this._setCurrentFolderId(folderId)
        this._toggleTreeSideBar()
        await this._loadItemsTableContent()
        // this.setQuantityInTable()
      }
    }
    // setQuantityInTable () {
    //   this.currentDocument.records.forEach((documentRecord) => {
    //     this.content.forEach((tableRecord) => {
    //       if (tableRecord.nomenklatura_id === documentRecord.nomenklatura_id) {
    //         tableRecord.kolichestvo = documentRecord.kolichestvo
    //       }
    //     })
    //   })
    // }
  },
  async mounted () {
    // load folders
    this.isLoading = true
    await this._loadFoldersTreeContent()
    this.open.push(0)
    this.isLoading = false
  }
}
</script>

<style lang="stylus">
  .tree-view-container {
    overflow:auto;
    height:calc(100vh - 57px - 48px - 48px - 36px)
    @media screen and (max-width: 959px) {
      flex-grow 1
      height: auto
    }
  }
    .scroll-area {
      position: relative;
      margin: auto;
      height:calc(100vh - 57px - 48px - 48px - 36px)
      @media screen and (max-width: 959px) {
        flex-grow 1
        height: auto
      }
    }

  .v-treeview {
    .v-treeview-node__label {
      font-size: 1em;
    }

    .v-treeview-node__root {
      height: 24px;
    }
  }

  .t-catalog-folders-container {
    //overflow: hidden;
    //height: 100%;
  }

  .toggle-button {
    //position: absolute;
    //right: 0;
  }
</style>
